import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/advertisement/ListAsideAd.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/author/AuthorArticleList.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/layout/GoTop.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/snv/components/TranslationsProvider.js");
;
import(/* webpackMode: "eager" */ "/snv/node_modules/next/dist/client/image-component.js");
